import isString from 'lodash/isString';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Collapse} from 'react-collapse';
import IconChevronDown from '@spothero/icons/chevron-down';
import IconChevronUp from '@spothero/icons/chevron-up';
import Button from '@spothero/ui/button';
import WithCollapsibleCard from './WithCollapsibleCard';

class CardContentPanel extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.node.isRequired,
        additionalTitleMarkup: PropTypes.node,
        preview: PropTypes.node,
        children: PropTypes.node.isRequired,
        isOpen: PropTypes.bool,
        showTitleToggle: PropTypes.bool,
        showContentOnPrint: PropTypes.bool,
        heightReady: PropTypes.bool,
        onMeasure: PropTypes.func.isRequired,
        onToggle: PropTypes.func.isRequired,
    };

    _renderContent(isPrintContent) {
        const {children, heightReady} = this.props;
        const contentClasses = classNames(
            'CardContentPanel-content',
            {'CardContentPanel-content-for-print': isPrintContent},
            {'CardContentPanel-content-hidden': !isPrintContent && !heightReady}
        );

        return <div className={contentClasses}>{children}</div>;
    }

    render() {
        const {
            className,
            title,
            isOpen,
            showContentOnPrint,
            onMeasure,
            onToggle,
            showTitleToggle,
            preview,
            additionalTitleMarkup,
        } = this.props;
        const classes = classNames(
            'CardContentPanel',
            {'CardContentPanel-open': isOpen},
            className
        );

        return (
            <div className={classes}>
                <div className="CardContentPanel-title">
                    {showTitleToggle && (
                        <Button
                            className="CardContentPanel-toggle"
                            onClick={onToggle}
                        >
                            {isString(title) ? (
                                <div className="CardContentPanel-title-heading">
                                    {title}
                                </div>
                            ) : (
                                title
                            )}
                            {isOpen ? <IconChevronUp /> : <IconChevronDown />}
                        </Button>
                    )}
                    {!showTitleToggle && (
                        <h2 className="CardContentPanel-title-heading">
                            <span dangerouslySetInnerHTML={{__html: title}} />
                        </h2>
                    )}
                    {!showTitleToggle && additionalTitleMarkup}
                </div>

                {!isOpen && preview && (
                    <div className="CardContentPanel-preview">{preview}</div>
                )}
                <Collapse
                    isOpened={isOpen}
                    onMeasure={onMeasure}
                    springConfig={{stiffness: 300, damping: 25}}
                >
                    {this._renderContent()}
                </Collapse>
                {showContentOnPrint && this._renderContent(showContentOnPrint)}
            </div>
        );
    }
}

export default WithCollapsibleCard(CardContentPanel);
